import PropTypes from "prop-types";
import React from "react";
import ProductgridList from "./ProductgridList";

const ShopProducts = ({ products, layout, partnerName }) => {
    return (
    <div className="shop-bottom-area mt-10">
      <div className={`row ${layout ? layout : ""} ${partnerName == "klikego" ? "" : "justify-content-md-center justify-content-sm-center"}`}>
        <ProductgridList products={products} spaceBottomClass="mb-10" partnerName={partnerName}/>
      </div>
    </div>
  );
};

ShopProducts.propTypes = {
  layout: PropTypes.string,
  products: PropTypes.array,
    partnerName: PropTypes.string
};

export default ShopProducts;
